class CollectionFilters {
  constructor() {
    this.form = document.getElementById('collection-filters-form');
    this.productGrid = document.getElementById('product-grid');
    this.productCount = document.querySelector('.collection-product-count');
    this.allProducts = [];
    this.priceMinInput = document.getElementById('price-min-input');
    this.priceMaxInput = document.getElementById('price-max-input');
    this.init();
  }

  init() {
    if (!this.form || !this.productGrid) return;
    
    // Store all products
    this.allProducts = Array.from(this.productGrid.querySelectorAll('.collection-item'));
    
    // Add event listeners to checkboxes
    const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.handleFilterChange());
    });

    // Add event listeners to price inputs
    if (this.priceMinInput && this.priceMaxInput) {
      this.priceMinInput.addEventListener('input', () => this.handleFilterChange());
      this.priceMaxInput.addEventListener('input', () => this.handleFilterChange());
    }

    // Apply filters on page load if URL has params
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.toString()) {
      this.applyFiltersFromURL();
    }
  }

  applyFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Check the appropriate checkboxes based on URL params
    if (urlParams.get('availability') === '1') {
      const checkbox = this.form.querySelector('input[name="availability"]');
      if (checkbox) checkbox.checked = true;
    }

    ['vendor', 'size', 'color'].forEach(filterType => {
      const param = urlParams.get(filterType);
      if (param) {
        const values = param.split(',');
        values.forEach(value => {
          const checkbox = this.form.querySelector(`input[name="${filterType}"][value="${value}"]`);
          if (checkbox) checkbox.checked = true;
        });
      }
    });

    this.filterProducts();
  }

  handleFilterChange() {
    const params = new URLSearchParams();
    const filters = {
      availability: [],
      vendor: [],
      size: [],
      color: []
    };

    const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(cb => {
      if (cb.checked) {
        const filterType = cb.dataset.filterType || cb.name;
        if (filters[filterType]) {
          filters[filterType].push(cb.value);
        }
      }
    });

    if (filters.availability.length > 0) {
      params.set('availability', '1');
    }
    if (filters.vendor.length > 0) {
      params.set('vendor', filters.vendor.join(','));
    }
    if (filters.size.length > 0) {
      params.set('size', filters.size.join(','));
    }
    if (filters.color.length > 0) {
      params.set('color', filters.color.join(','));
    }

    // Add price params
    if (this.priceMinInput && this.priceMaxInput) {
      const minPrice = this.priceMinInput.value;
      const maxPrice = this.priceMaxInput.value;
      const originalMin = this.priceMinInput.min;
      const originalMax = this.priceMaxInput.max;
      
      if (minPrice !== originalMin || maxPrice !== originalMax) {
        params.set('price_min', minPrice);
        params.set('price_max', maxPrice);
      }
    }

    const baseUrl = window.location.pathname;
    const newUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    
    // Update URL without refresh
    window.history.pushState({}, '', newUrl);
    
    // Filter products
    this.filterProducts();
    
    // Update active filters display
    this.updateActiveFilters(filters);
  }

  filterProducts() {
    const urlParams = new URLSearchParams(window.location.search);
    const filters = {
      availability: urlParams.get('availability') === '1',
      vendors: urlParams.get('vendor') ? urlParams.get('vendor').split(',') : [],
      sizes: urlParams.get('size') ? urlParams.get('size').split(',') : [],
      colors: urlParams.get('color') ? urlParams.get('color').split(',') : [],
      priceMin: urlParams.get('price_min') ? parseFloat(urlParams.get('price_min')) : null,
      priceMax: urlParams.get('price_max') ? parseFloat(urlParams.get('price_max')) : null
    };

    let visibleCount = 0;

    this.allProducts.forEach(product => {
      let show = true;

      // Check availability
      if (filters.availability) {
        const isAvailable = product.dataset.available === 'true';
        if (!isAvailable) show = false;
      }

      // Check vendor
      if (show && filters.vendors.length > 0) {
        const productVendor = product.dataset.vendor;
        if (!filters.vendors.includes(productVendor)) show = false;
      }

      // Check size
      if (show && filters.sizes.length > 0) {
        const productSizes = product.dataset.sizes.split(',').filter(s => s.trim());
        const hasSize = filters.sizes.some(size => productSizes.includes(size));
        if (!hasSize) show = false;
      }

      // Check color
      if (show && filters.colors.length > 0) {
        const productColors = product.dataset.colors.split(',').filter(c => c.trim());
        const hasColor = filters.colors.some(color => productColors.includes(color));
        if (!hasColor) show = false;
      }

      // Check price
      if (show && (filters.priceMin !== null || filters.priceMax !== null)) {
        const productPrice = parseFloat(product.dataset.price);
        if (filters.priceMin !== null && productPrice < filters.priceMin) show = false;
        if (filters.priceMax !== null && productPrice > filters.priceMax) show = false;
      }

      // Show or hide product
      if (show) {
        product.style.display = '';
        visibleCount++;
      } else {
        product.style.display = 'none';
      }
    });

    // Update product count
    if (this.productCount) {
      const totalProducts = this.allProducts.length;
      this.productCount.textContent = `${visibleCount} product${visibleCount !== 1 ? 's' : ''}`;
    }

    // Show "no products" message if needed
    this.showNoProductsMessage(visibleCount === 0);
  }

  showNoProductsMessage(show) {
    let noProductsMsg = this.productGrid.querySelector('.no-products');
    
    if (show && !noProductsMsg) {
      noProductsMsg = document.createElement('div');
      noProductsMsg.className = 'no-products';
      noProductsMsg.innerHTML = '<p>No products found matching your filters.</p>';
      this.productGrid.appendChild(noProductsMsg);
    } else if (!show && noProductsMsg) {
      noProductsMsg.remove();
    }
  }

  updateActiveFilters(filters) {
    const activeFiltersWrapper = document.querySelector('.active-filters-wrapper');
    const clearFiltersWrapper = document.querySelector('.filter-clear-wrapper');
    
    const hasActiveFilters = filters.availability.length > 0 || 
                            filters.vendor.length > 0 || 
                            filters.size.length > 0 || 
                            filters.color.length > 0;

    if (!hasActiveFilters) {
      if (activeFiltersWrapper) activeFiltersWrapper.remove();
      if (clearFiltersWrapper) clearFiltersWrapper.remove();
      return;
    }

    // Create active filters HTML
    let activeFiltersHTML = '<p class="active-filters-title">Active Filters:</p><div class="active-filters-tags">';
    
    if (filters.availability.length > 0) {
      activeFiltersHTML += '<span class="active-filter-tag">Available Only <a href="#" class="remove-filter" data-filter="availability">×</a></span>';
    }

    filters.vendor.forEach(vendor => {
      activeFiltersHTML += `<span class="active-filter-tag">Brand: ${vendor} <a href="#" class="remove-filter" data-filter="vendor" data-value="${vendor}">×</a></span>`;
    });

    filters.size.forEach(size => {
      activeFiltersHTML += `<span class="active-filter-tag">Size: ${size} <a href="#" class="remove-filter" data-filter="size" data-value="${size}">×</a></span>`;
    });

    filters.color.forEach(color => {
      activeFiltersHTML += `<span class="active-filter-tag">Color: ${color} <a href="#" class="remove-filter" data-filter="color" data-value="${color}">×</a></span>`;
    });

    activeFiltersHTML += '</div>';

    // Update or create active filters wrapper
    if (activeFiltersWrapper) {
      activeFiltersWrapper.innerHTML = activeFiltersHTML;
    } else {
      const wrapper = document.createElement('div');
      wrapper.className = 'active-filters-wrapper';
      wrapper.innerHTML = activeFiltersHTML;
      
      if (clearFiltersWrapper) {
        clearFiltersWrapper.insertAdjacentElement('afterend', wrapper);
      } else {
        this.form.insertAdjacentElement('beforeend', wrapper);
      }
    }

    // Show/create clear filters button
    if (!clearFiltersWrapper) {
      const clearBtn = document.createElement('div');
      clearBtn.className = 'filter-clear-wrapper';
      clearBtn.innerHTML = '<a href="#" class="filter-clear-btn">Clear All Filters</a>';
      
      const lastAccordion = this.form.querySelector('.filter-accordion:last-of-type');
      if (lastAccordion) {
        lastAccordion.insertAdjacentElement('afterend', clearBtn);
      }
    }

    // Add event listeners to remove filter buttons
    this.attachRemoveFilterListeners();
  }

  attachRemoveFilterListeners() {
    const removeButtons = document.querySelectorAll('.remove-filter');
    removeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const filterType = btn.dataset.filter;
        const value = btn.dataset.value;

        if (filterType === 'availability') {
          const checkbox = this.form.querySelector('input[name="availability"]');
          if (checkbox) checkbox.checked = false;
        } else {
          const checkbox = this.form.querySelector(`input[name="${filterType}"][value="${value}"]`);
          if (checkbox) checkbox.checked = false;
        }

        this.handleFilterChange();
      });
    });

    // Clear all filters button
    const clearBtn = document.querySelector('.filter-clear-btn');
    if (clearBtn) {
      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(cb => cb.checked = false);
        this.handleFilterChange();
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
});
